<script lang="ts">
  import { Link } from 'svelte-navigator'

  export let route
  export let title
</script>

<Link to={route} style={'color: white;'}>
  <div class="link-wrapper">
    <span>{title}</span><span
      ><svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.475 2C17.475 1.26225 16.8769 0.664189 16.1392 0.664189L4.11689 0.664189C3.37914 0.664189 2.78108 1.26225 2.78108 2C2.78108 2.73775 3.37914 3.33581 4.11689 3.33581L14.8034 3.33581V14.0223C14.8034 14.76 15.4014 15.3581 16.1392 15.3581C16.8769 15.3581 17.475 14.76 17.475 14.0223V2ZM1.94456 18.0837L17.0837 2.94456L15.1946 1.05544L0.0554392 16.1946L1.94456 18.0837Z"
          fill="white"
        />
      </svg></span
    >
  </div>
</Link>

<style>
  .link-wrapper {
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #313131;
    min-height: calc((60vh - 55px - 60px - 8vh) / 5);
  }

  span {
    padding: 1.5rem;
  }

  @media (max-width: 520px) {
    .link-wrapper {
      min-height: calc((60vh - 55px - 60px - 5vh) / 5);
    }
  }
</style>
